var Institucional = function () {

    this.init = function () {
		$('[data-component="institucional"] table').each(function(){
			if($(window).width() <= 768){
				colunas = $(this).find('tr:first td').length;
				$(this).css('width', colunas * 92 + 'vw');
			}		

			if($(this).find('.texto-titulo-tabela').length > 0){
				$(this).addClass('table-borderless');
			}

			$(this).addClass('table');
			$('<div class="table-responsive"></div>').append($(this).clone()).insertBefore($(this));
			$(this).remove();


			
		});
	}
    return this.init();
}